import { render, staticRenderFns } from "./addOrEditComment.vue?vue&type=template&id=c408f63a&scoped=true"
import script from "./addOrEditComment.vue?vue&type=script&lang=js"
export * from "./addOrEditComment.vue?vue&type=script&lang=js"
import style0 from "./addOrEditComment.vue?vue&type=style&index=0&id=c408f63a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c408f63a",
  null
  
)

export default component.exports